import Image from 'app/Components/Shared/Image/image';
import React,{useEffect}  from 'react';
import {connect} from 'react-redux';
import BtnSubmit  from '../../../../Shared/Buttons/BtnSubmit';
import './predefineStep.scss';
import successImg from '../../images/natavb35.png';
import gaParams from '../../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../../utilities/analytics/tracking';
import {setNextWizardStep } from '../../routerActivationWizardBlockSlice';

const PredefineStep = (props) => {

  useEffect(()=>{
    gaEvent(gaParams.ROUTER_ACTIVATION_WIZARD_PREDEFINE_STEP_DISPLAY.category, 
      gaParams.ROUTER_ACTIVATION_WIZARD_PREDEFINE_STEP_DISPLAY.eventType, 
      gaParams.ROUTER_ACTIVATION_WIZARD_PREDEFINE_STEP_DISPLAY.eventParams);
  },[]);


  async function setNextStep() {

    gaEvent(gaParams.ROUTER_ACTIVATION_WIZARD_PREDEFINE_STEP_CLICK_CONNECTED_BUTTON.category, 
      gaParams.ROUTER_ACTIVATION_WIZARD_PREDEFINE_STEP_CLICK_CONNECTED_BUTTON.eventType, 
      gaParams.ROUTER_ACTIVATION_WIZARD_PREDEFINE_STEP_CLICK_CONNECTED_BUTTON.eventParams);

    var obj={
      RequestId: props.RequestId,
      Step: props.Step,
      CurrentStep: props.CurrentStep
    };
    await props.setNextWizardStep(obj);
  }

    return(<div className='predefine-step'>
              <div className='predefine-step-top-circle'>1</div>
              <div className='predefine-step-title'>מתחילים!</div>
              <div className='predefine-step-text'>חברו את הסופר ראוטר בדיוק כמו בתרשים</div>
              <div className='predefine-step-img'><Image height="350" width="300" src={successImg} /></div>
              <div className='predefine-step-button'><BtnSubmit text='חיברתי' onclick={setNextStep}/></div>
        </div>);
};

const mapStateToProps = (state) => {
    return {
      RequestId: state.RouterActivationWizardBlock.wizardRequestId,
      CurrentStep: state.RouterActivationWizardBlock.wizardRequestId,
      Step: state.RouterActivationWizardBlock.step
    };
};

const mapDispatchToProps = {
  setNextWizardStep
};

export default connect(mapStateToProps,mapDispatchToProps)(PredefineStep);